module.exports = __webpack_public_path__ + "img/linkedin.fd0d5546.png";